const authServiceUrl = 'https://go-dev-api2.augmedix.com/auth/v1';
const providerServiceUrl = 'https://go-dev-api2.augmedix.com/provider/v1';
const appointmentServiceUrl = 'https://go-dev-api2.augmedix.com/appointment/v1';
const ehrServiceUrl = 'https://go-dev-api2.augmedix.com/ehr/v1';
const macrosServiceUrl = 'https://go-dev-api2.augmedix.com/macros/v1';
const transcriptServiceUrl = 'https://go-dev-ml-api2.augmedix.com/transcript/v1';
const gwpServiceUrl = 'https://go-dev-api2.augmedix.com/gwp/v1';
const signupServiceUrl = 'https://go-dev-api2.augmedix.com/signup/v1';
const graphqlApiUrl = 'https://go-dev-api2.augmedix.com/apollo-gateway/v1/graphql';
const nrtServerUrl = 'https://g-dev-go-nrt.augmedix.com';
const userManagementServiceUrl = 'https://go-dev-api2.augmedix.com/usermanagement/v1';
const ssoServiceUrl = 'https://go-dev-api2.augmedix.com/saml/v1';
const textExpanderServiceUrl = 'https://go-dev-api2.augmedix.com/textexpander/v1';

export const devUrls = {
  authServiceUrl,
  providerServiceUrl,
  appointmentServiceUrl,
  ehrServiceUrl,
  macrosServiceUrl,
  transcriptServiceUrl,
  gwpServiceUrl,
  signupServiceUrl,
  graphqlApiUrl,
  nrtServerUrl,
  userManagementServiceUrl,
  ssoServiceUrl,
  textExpanderServiceUrl,
};
